// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "claire_failure_group_member".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "claire_failure_group_member" table (1:1 with a DB row, on the wire). */
export const claireFailureGroupMemberAtomSchema = z.object({
    observationId: z.string(),
    groupId: z.string(),
    traceId: z.string(),
    conversationId: z.string().nullable(),
    organizationId: z.string().nullable(),
    failureType: z.string().nullable(),
    turnAt: z.string().datetime(),
    addedByUserId: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=claireFailureGroupMember.js.map